import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Box, CircularProgress, Paper } from '@material-ui/core'
import { useStyles } from './style'
import _ from 'lodash'
import { dashboardService } from '../../Services/Dashboard/Dashboard'
import * as messageTypes from '../../utils/messageTypes'
import { DisplayMessage, ComponentLoader } from '../../Components'
import RefreshIcon from '@material-ui/icons/Refresh'

function Summary(props) {
  const classes = useStyles()
  const [summaryData, setSummaryData] = useState()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()

  const getSummary = () => {
    const { currentUser } = props
    setLoading(true)
    dashboardService.getSummary(currentUser.account_id, props.account)
      .then(summaryData => {
        setSummaryData(summaryData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  useEffect(() => {
    if (props.account) {
      getSummary()
    }
  }, [props.account])

  return (
    <>
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => { setOpen(false) }} />
      <Box p={2}>
        <Box className={classes.summaryheaderWrapper} display="flex">
          <Box flexGrow={1}>Summary</Box>
          <Box ><RefreshIcon className={classes.refreshIcon} onClick={getSummary} /></Box>
        </Box>
        {loading ? <ComponentLoader loading={loading} style={{ height: 200 }} /> :
          <div className={classes.cardWrapper}>
            <Paper className={classes.card} variant="outlined">
              <div className={classes.cardData}>System Enrolled</div>
              <span className={classes.cardValue}>{_.get(summaryData, 'systems_enrolled', '-')}</span>
            </Paper>
            <Paper className={classes.card} variant="outlined">
              <div className={classes.cardData}>Programs</div>
              <span className={classes.cardValue}>{_.get(summaryData, 'programs', '-')}</span>
            </Paper>
            <Paper className={classes.card} variant="outlined">
              <div className={classes.cardData}>Events</div>
              <span className={classes.cardValue}>{_.get(summaryData, 'events', '-')}</span>
            </Paper>
            <Paper className={classes.card} variant="outlined">
              <div className={classes.cardData}>Virtual Power Plants</div>
              <span className={classes.cardValue}>{_.get(summaryData, 'vpp', '-')}</span>
            </Paper>
            <Paper className={classes.card} variant="outlined">
              <div className={classes.cardData}>Users</div>
              <span className={classes.cardValue}>{_.get(summaryData, 'users', '-')}</span>
            </Paper>
          </div>}
      </Box>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(Summary)